module.exports = __webpack_public_path__ + "static/poster-DEI-choice-sunflower-der-web-f063cc3e81548bb842c914aabe07b597.png";